import http from './api'

const route = 'app/comercial/analisemargem2/'

export default {
  showAnaliseMargem2Faturamento: (dataInicial, dataFinal, select, area, rede, supervisor, classificacao, linhasProducao, produtos, cidades, tokencontrato) => {
    return http.post(route + 'showAnaliseMargem2Faturamento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnaliseMargem2GrupoProdutos: (dataInicial, dataFinal, select, area, rede, supervisor, classificacao, linhasProducao, produtos, cidades, tokencontrato) => {
    return http.post(route + 'showAnaliseMargem2GrupoProdutos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnaliseMargem2Representante: (dataInicial, dataFinal, select, area, rede, supervisor, classificacao, linhasProducao, produtos, cidades, tokencontrato) => {
    return http.post(route + 'showAnaliseMargem2Representante', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnaliseMargemArea: (dataInicial, dataFinal, select, area, rede, supervisor, classificacao, linhasProducao, produtos, cidades, tokencontrato) => {
    return http.post(route + 'showAnaliseMargemArea', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },
}
